import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useProductComparisonBarContext } from "@/components/Product/ProductComparisonBar/context/productComparisonBar.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
    children?: ReactNode;
};

export const ClearButton = ({ className, children }: Props) => {
    const { t } = useGranite();

    const { clear, toggle } = useProductComparisonBarContext();

    const handleOnClearClick = () => {
        toggle();
        clear();
    };

    return (
        <Button
            color={"link"}
            type={"button"}
            className={cn("tw:p-0 tw:mt-4 tw:ml-4", className)}
            onClick={handleOnClearClick}
        >
            {children ?? t("productComparison.removeAll")}
        </Button>
    );
};
